"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JwtError = void 0;
class JwtError extends Error {
    constructor() {
        super("The JWT wasn't verified and thus this data can not be trusted");
    }
}
exports.JwtError = JwtError;
